export default "__VITE_ASSET__D1ExK7wJ__"